import Lenis from 'lenis'
import { object } from './_obj.js';
import { nav } from './_nav.js';
import { wwdImages } from './_wwdImg.js';
import { cursor } from './_cursor.js';
let Block = {
	top: 0,
	show: 0
}
let Works = {
	top: 0,
	show: 0,
	target: null
}
let workBlocks = [];
/*
座標
elem.getBoundingClientRect()
*/
let $this;
export class Scroll {
	constructor(){
		$this = this;
		this.topD = 0;
		this.btmD = this.topD + window.innerHeight;
		this.animations = new Array();
		this.blocks 	= new Array();
		this.observer;
		this.lenis = new Lenis();
		this.wwd = document.querySelector("#wwd");
		this.members = document.querySelector("#member");
		this.isSP = document.documentElement.classList.contains("mobile");
		this.reloadObserver();
		this.resize();
		this.startLenis();
	}
	startLenis(){
		let $this = this;
		$this.lenis.on('scroll', (e) => {
			$this.topD = e.scroll;
			$this.checkScroll();
		});
		function raf(time) {
			$this.lenis.raf(time)
			requestAnimationFrame(raf)
		}
		
		requestAnimationFrame(raf);
		this.start();
	}
	resize(){
		workBlocks = [];
		let $works = document.querySelectorAll("#wwd .c-list_content ul li");
		let $content = document.querySelector("#wwd .c-content");
		let startY = Math.floor( $content.getBoundingClientRect().top + window.pageYOffset );
		$works.forEach( ($w, index) => {
			let _w = object(Works);
			_w.target = $w;
			_w.top = startY + window.innerHeight*1.5*index;
			workBlocks.push(_w);
		});
	}
	start(){
		let $body = document.querySelector("body");
		$body.classList.add("active");
		this.resize();
		if( 'scrollRestoration' in history ){
			history.scrollRestoration = 'manual';
		}
		if( $this.isSP ){
			window.scrollTo(0, 0);
		} else {
			$this.lenis.scrollTo(0, { immediate: true });
		}
		cursor.init();
		wwdImages.init();
		nav.active();
	}
	reloadObserver(){
		let $this = this;
		$this.resize();
		if($this.observer){
			$this.observer.disconnect();
		}
		this.setObserver(null);
	}
	
	setObserver(root){
		let $this = this;
		let $animates = document.querySelectorAll("[data-animate]");
		if( $animates ){
			//DOMにdata-repeat="1"で画面外にいったときにanimateのclassを削除
			let AnimateOptions = {
				root: root ? root : null,
				rootMargin: "-33% 0px",
				threshold: 0
			}
			//data-animate用observer
			$this.observer = new IntersectionObserver($this.checkAnimate, AnimateOptions);
			//console.log($animates, AnimateOptions, $this.observer);
			$animates.forEach( item => {
				$this.observer.observe(item);
			});
		}
	}
	checkAnimate(items){
		items.forEach( (item) => {
			if( item.isIntersecting ){
				//console.log("interSectiong:", item.target);
				startAnimate( item.target );
			}else{
				if( item.target.getAttribute("data-repeat") === "1" ){
					deleteAnimate(item.target);
				}
			}
		});
		
		function startAnimate( $target ){
			if( !$target.classList.contains("animate") ){
				$target.classList.add("animate");
			}
		}
		function deleteAnimate( $target ){
			if( $target.classList.contains("animate") ){
				$target.classList.remove("animate");
			}
		}
	}
	checkScroll(){
		let $this = this;
		$this.btmD = $this.topD + window.innerHeight;
		let center = $this.topD - window.innerHeight/ 3;
		
		workBlocks.forEach((block, i) => {
			const nextTop = workBlocks[i + 1] ? workBlocks[i + 1].top : Infinity;
			
			if (center >= block.top && center < nextTop) {
				const $ul = document.querySelector("#wwd .c-list_content ul");
				const $list = $ul.querySelectorAll("li");
				if ($ul) {
					// 新しいactiveクラスを付与
					
					if( window.innerWidth < 864 ){
						if( !$list[i].classList.contains("active") ){
							$list.forEach( ($l, index) => {
								if( index === i ){
									$l.classList.add("active");
								}else{
									if( $l.classList.contains("active") ){
										$l.classList.remove("active");
									}
								}
							});
						}
						/*
						if( !$ul.classList.contains(`active${i}`) ){
							workBlocks.forEach((_, j) => {
								$ul.classList.remove(`active${j}`);
							});
							$ul.classList.add(`active${i}`);
						}
						*/
					}else{
						$list.forEach( ($l, index) => {
							if( $l.classList.contains("active") ){
								$l.classList.remove("active");
							}
						})
					}
				}
			}
		});
		let showPoint = Math.floor( $this.wwd.getBoundingClientRect().top + window.pageYOffset );
		let $html = document.documentElement;
		if( $this.topD >= window.innerHeight/2 ){
			if( !$html.classList.contains("scrolled") ){
				$html.classList.add("scrolled");
			}
		}else{
			if( $html.classList.contains("scrolled") ){
				$html.classList.remove("scrolled");
			}
		}
		/*
		let hideWWDPoint = Math.floor( $this.members.getBoundingClientRect().top + window.pageYOffset );
		if( $this.btmD >= hideWWDPoint ){
			if( !$this.wwd.classList.contains("hide") ){
				$this.wwd.classList.add("hide");
			}
		}else{
			if( $this.wwd.classList.contains("hide") ){
				$this.wwd.classList.remove("hide");
			}
		}
		*/
	}
	getTop($dom, offset){
		let t = Math.floor( $dom.getBoundingClientRect().top + window.pageYOffset );
		return [ t, Math.floor( t + offset )]
	}
}